module.exports = __webpack_public_path__ + "static/media/IconPlusWhite.45423a58.svg";